import { withAppContext } from '@client/modules/app-context/react';
import React from 'react';
import styles from './styles.scss';

export const WelcomePageHeader = withAppContext(() => {
  return <div className={styles.header} data-test={'welcome-page-header'}></div>;
});
